import { createAction } from 'redux-starter-kit';
import twoFactorService from '../../services/twoFactorService';
import authActions from './auth';

// Action creators
const set2FAStatus = createAction('twoFactor/set_status');
const set2FASetupData = createAction('twoFactor/set_setup_data');
const clear2FASetupData = createAction('twoFactor/clear_setup_data');
const set2FABackupCodes = createAction('twoFactor/set_backup_codes');
const set2FALoading = createAction('twoFactor/set_loading');
const set2FAError = createAction('twoFactor/set_error');

// Thunk actions
const checkStatus = () => async (dispatch) => {
  try {
    dispatch(set2FALoading(true));
    const status = await twoFactorService.checkStatus();
    dispatch(set2FAStatus(status));
    dispatch(set2FALoading(false));
    return status;
  } catch (error) {
    dispatch(set2FALoading(false));
    dispatch(set2FAError(error.message));
    throw error;
  }
};

const setup = () => async (dispatch) => {
  try {
    dispatch(set2FALoading(true));
    const setupData = await twoFactorService.setup();
    dispatch(set2FASetupData(setupData));
    dispatch(set2FALoading(false));
    return setupData;
  } catch (error) {
    dispatch(set2FALoading(false));
    dispatch(set2FAError(error.message));
    throw error;
  }
};

const confirm = (token) => async (dispatch, getState) => {
  try {
    dispatch(set2FALoading(true));
    const result = await twoFactorService.confirm(token);
    dispatch(set2FAStatus({ enabled: true, method: 'totp' }));

    // Mettre à jour l'authUser pour indiquer que le 2FA est configuré
    const currentUser = getState().auth.authUser;
    if (currentUser) {
      dispatch(authActions.resyncAuthUser({
        ...currentUser,
        requires_2fa_setup: false,
        two_factor_enabled: true,
      }));
    }

    dispatch(set2FALoading(false));
    return result;
  } catch (error) {
    dispatch(set2FALoading(false));
    dispatch(set2FAError(error.message));
    throw error;
  }
};

const disable = (password) => async (dispatch, getState) => {
  try {
    dispatch(set2FALoading(true));
    const result = await twoFactorService.disable(password);
    dispatch(set2FAStatus({ enabled: false, method: null }));
    dispatch(clear2FASetupData());

    // Mettre à jour l'authUser pour forcer la reconfiguration du 2FA
    const currentUser = getState().auth.authUser;
    if (currentUser) {
      dispatch(authActions.resyncAuthUser({
        ...currentUser,
        requires_2fa_setup: true,
      }));
    }

    dispatch(set2FALoading(false));
    return result;
  } catch (error) {
    dispatch(set2FALoading(false));
    dispatch(set2FAError(error.message));
    throw error;
  }
};

const regenerateBackupCodes = (password) => async (dispatch) => {
  try {
    dispatch(set2FALoading(true));
    const result = await twoFactorService.regenerateBackupCodes(password);
    dispatch(set2FABackupCodes(result.backup_codes));
    dispatch(set2FALoading(false));
    return result;
  } catch (error) {
    dispatch(set2FALoading(false));
    dispatch(set2FAError(error.message));
    throw error;
  }
};

const verify = (token, tempToken, trustDevice = false, deviceName = '') => async (dispatch) => {
  try {
    dispatch(set2FALoading(true));
    const user = await twoFactorService.verify(token, tempToken, trustDevice, deviceName);
    dispatch(set2FALoading(false));
    return user;
  } catch (error) {
    dispatch(set2FALoading(false));
    dispatch(set2FAError(error.message));
    throw error;
  }
};

export default {
  // Action creators
  set2FAStatus,
  set2FASetupData,
  clear2FASetupData,
  set2FABackupCodes,
  set2FALoading,
  set2FAError,

  // Thunk actions
  checkStatus,
  setup,
  confirm,
  disable,
  regenerateBackupCodes,
  verify,
};
